import React, { useState, useEffect } from "react";
import clsx from "clsx";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    InputAdornment,
    IconButton,
    FormControl,
    InputLabel,
    Input,
    FormControlLabel
} from "@mui/material";
import BackButton from "../../components/BackButton/BackButton";
import SearchIcon from "@mui/icons-material/Search";


// import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch, AiOutlineUser } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";

import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import SOLogout from "../../components/Logout/SOLogout";
import FileBase64 from "../../components/Upload/UploadFile";
import Util from "../../validation/index";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { partnerGetMultipleMappingListReq } from "../../redux/actions/getMultipleMappingListForPartnerAction"
import { partnerDivisionListReq } from '../../redux/actions/divisionListAgentPartnerAction'
import { partnerDistrictListReq } from "../../redux/actions/districtListAgentPartnerAction"
import { partnerThanaListReq } from "../../redux/actions/thanaListAgentPartnerAction";
import { partnerUnionListReq } from "../../redux/actions/unionListAgentPartnerAction";
import { partnerDealerListReq } from '../../redux/actions/dealerListPartnerAction';
import { partnerGetMultipleSelectListReq } from "../../redux/actions/getMultipleSelectForPartnerAction"

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650
    },
    margin: {
        margin: theme.spacing(1)
    },
    root: {
        display: "flex",
        flexWrap: "wrap"
    },
    textField: {
        width: "25ch"
    }
}));

const DealerMultipleMapping = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [editOpenMapDsr, setEditOpenMapDsr] = useState(false)

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [editDivision, setEditDivision] = useState("");
    const [editDistrict, setEditDistrict] = useState("");
    const [editThana, setEditThana] = useState("");
    const [editUnion, setEditUnion] = useState("");

    const partnerloginUser = useSelector(({ login }) => login);
    // var authToken = partnerloginUser.data.AuthToken;
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;

    const [setAddUpdateDivisionListStatus, setSetAddUpdateDivisionListStatus] = useState(false);
    const [setAddUpdateDivisionListArray, setSetAddUpdateDivisionListArray] = useState([]);

    const [setAddUpdateDistrictListStatus, setSetAddUpdateDistrictListStatus] = useState(false);
    const [setAddUpdateDistrictListArray, setSetAddUpdateDistrictListArray] = useState([]);


    const [setAddUpdateThanaListStatus, setSetAddUpdateThanaListStatus] = useState(false);
    const [setAddUpdateThanaListArray, setSetAddUpdateThanaListArray] = useState([]);

    const [setAddUpdateUnionListStatus, setSetAddUpdateUnionListStatus] = useState(false);
    const [setAddUpdateUnionListArray, setSetAddUpdateUnionListArray] = useState([]);

    const [getDealerMultiplMappingListStatus, setGetDealerMultiplMappingListStatus] = useState(false);
    const [getDealerMultiplMappingListStatusArray, setGetDealerMultiplMappingListStatusArray] = useState([]);



    const [getDealerListStatus, setGetDealerListStatus] = useState(false);
    const [getDealerListArray, setGetDealerListArray] = useState([]);

    const [mapDsrStatus, setMapDsrStatus] =
        useState(false);
    const [mapDsrStatusResArray, setMapDsrStatusResArray] =
        useState("");
    const [checkListNotification, setCheckListNotification] = useState(false)
    const [reqArr, setReqArr] = useState([])


    const [getIsDealUsed, setGetIsDealUsed] = useState("");


    const [user, setUser] = useState({
        getRole: "",
        division: "",
        district: "",
        thana: "",
        union: ""
    });
    const {
        getRole,
        division,
        district,
        thana,
        union
    } = user



    const onInputChangeMod = ({ target: { name, value } }, type) => {

        const obj = {
            ...user,

        };
        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.alphaNumeric(value) ? value : obj[name];
        } else {
            // obj[name] = value.trim()
            obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
        }
        setUser(obj);
    }


    const handleClose = () => {
        setEditOpenMapDsr(false)
        // setGetEmailOtp("")
    }
    const handleChange = ({ target: { name, value } }) => {
        if (name === "getIsDealUsed") {
            setGetIsDealUsed(value);

            // console.log('Dropdown: ', getIsDealUsed)
        }
        if (name === "EditDivision") {
            // setCurrency(value);
            // setEditCurrency(value);
            setEditDivision(value == "Select Division" ? "" : value);
        }
        if (name === "EditDistrict") {
            // setCurrency(value);
            // setEditCurrency(value);
            setEditDistrict(value == "Select District" ? "" : value);
        }
        if (name === "EditThana") {

            setEditThana(value == "Select Thana" ? "" : value);
        }
        if (name === "EditUnion") {

            setEditUnion(value == "Select Union" ? "" : value);
        }
    };

    const handleNoticationClose = () => {

        setCheckListNotification(false)
    };
    const setDivisionList = useSelector(
        ({ partnerDivisionListAgent }) => partnerDivisionListAgent
    )
    const setDistrictList = useSelector(
        ({ partnerDistrictListAgent }) => partnerDistrictListAgent
    )

    const setThanaList = useSelector(
        ({ partnerThanaListAgent }) => partnerThanaListAgent
    )

    const setUnionList = useSelector(
        ({ partnerUnionListAgent }) => partnerUnionListAgent
    )

    const getPartnerMultipleMappingListRes = useSelector(
        ({ partnerGetMultipleMappingLists }) => partnerGetMultipleMappingLists
    )

    const getDealerListRes = useSelector(({ partnerDealerLists }) => partnerDealerLists);

    const getCheckListRes = useSelector(({ partnerGetMultipleSelectLists }) => partnerGetMultipleSelectLists)



    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const setAddUpdateDivisionListReq = () => {
        setSetAddUpdateDivisionListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",


            }
        }
        dispatch(partnerDivisionListReq(req, authToken))
    }
    const AddUpdateDivisionListFunc = () => {
        if (setAddUpdateDivisionListStatus) {
            if (setDivisionList.data.status == "success") {
                setSetAddUpdateDivisionListArray(setDivisionList.data.list);
            }
            if (setDivisionList.data.status == "failed") {
                setSetAddUpdateDivisionListArray(setDivisionList.data);
            }
        }
    };
    useEffect(() => {
        AddUpdateDivisionListFunc();
    }, [setDivisionList.data.status]);
    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {

            setAddUpdateDivisionListReq()

        }
    }, [regenerateTokenRes.data.status])

    const setAddUpdateDistrictListReq = () => {
        setSetAddUpdateDistrictListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                district: editDivision

            }
        }
        dispatch(partnerDistrictListReq(req, authToken))
    }

    const AddUpdateDistrictListFunc = () => {
        if (setAddUpdateDistrictListStatus) {
            if (setDistrictList.data.status == "success") {
                setSetAddUpdateDistrictListArray(setDistrictList.data.list);
            }
            if (setDistrictList.data.status == "failed") {
                setSetAddUpdateDistrictListArray(setDistrictList.data);
            }
        }
    };

    useEffect(() => {
        if (editDivision) {
            setAddUpdateDistrictListReq()
        }
    }, [editDivision])
    useEffect(() => {
        AddUpdateDistrictListFunc()
    }, [setDistrictList.data.status])

    // useEffect(() => {
    //     if (division) {
    //         setAddUpdateDistrictListReq()
    //     }
    // }, [division])

    const setAddUpdateThanaListReq = () => {
        setSetAddUpdateThanaListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                district: editDistrict

            }
        }
        dispatch(partnerThanaListReq(req, authToken))
    }

    const AddUpdateThanaListFunc = () => {
        if (setAddUpdateThanaListStatus) {
            if (setThanaList.data.status == "success") {
                setSetAddUpdateThanaListArray(setThanaList.data.list);
            }
            if (setThanaList.data.status == "failed") {
                setSetAddUpdateThanaListArray(setThanaList.data);
            }
        }
    };
    useEffect(() => {
        if (editDistrict) {
            setAddUpdateThanaListReq()
        }
    }, [editDistrict])

    useEffect(() => {
        AddUpdateThanaListFunc();
    }, [setThanaList.data.status]);

    // useEffect(() => {
    //     if (division) {
    //         setAddUpdateThanaListReq()
    //     }
    // }, [division])


    const setAddUpdateUnionListReq = () => {
        setSetAddUpdateUnionListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                district: editDistrict,
                thana: editThana

            }
        }
        dispatch(partnerUnionListReq(req, authToken))
    }

    const AddUpdateUnionListFunc = () => {
        if (setAddUpdateUnionListStatus) {
            if (setUnionList.data.status == "success") {
                setSetAddUpdateUnionListArray(setUnionList.data.list);
            }
            if (setUnionList.data.status == "failed") {
                setSetAddUpdateUnionListArray(setUnionList.data);
            }
        }
    };
    useEffect(() => {
        setAddUpdateUnionListReq()
    }, [editDivision, editThana])

    useEffect(() => {
        AddUpdateUnionListFunc();
    }, [setUnionList.data.status]);

    useEffect(() => {

        // setEditDivision('');
        setEditDistrict('');
        setEditThana('');
        setEditUnion('')

    }, [editDivision])

    // useEffect(() => {
    //     if (division && thana) {
    //         setAddUpdateUnionListReq()
    //     }
    // }, [division, thana])

    const getMultipleMappingListPartnerReq = () => {
        setIsLoading(true);
        setGetDealerMultiplMappingListStatus(true)
        const Request = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                division: editDivision === "Select Divison" ? "" : editDivision,
                district: editDistrict,
                thana: editThana,
                union: editUnion,
                role: getRole,
            }
        }
        dispatch(partnerGetMultipleMappingListReq(Request, authToken))
    }

    const getMultipleMappingListPartnerFunc = () => {
        if (getDealerMultiplMappingListStatus) {
            if (getPartnerMultipleMappingListRes.data.status == "success") {
                setGetDealerMultiplMappingListStatusArray([].concat(getPartnerMultipleMappingListRes.data.dsrList));
                setIsLoading(false);


            }
            if (getPartnerMultipleMappingListRes.data.status == "failed") {
                setIsLoading(false);

                setGetDealerMultiplMappingListStatusArray(getPartnerMultipleMappingListRes.data);
                if (
                    getPartnerMultipleMappingListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getPartnerMultipleMappingListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getPartnerMultipleMappingListRes.data.status == "Failed") {
                setGetDealerMultiplMappingListStatusArray(getPartnerMultipleMappingListRes.data);
                if (
                    getPartnerMultipleMappingListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getPartnerMultipleMappingListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getPartnerMultipleMappingListRes.data.status == "NOT FOUND") {
                setGetDealerMultiplMappingListStatusArray([]);
                // setShow(true);
            }
        }
    }

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {

            getMultipleMappingListPartnerReq();
        }
    }, [regenerateTokenRes.data.status]);

    useEffect(() => {
        getMultipleMappingListPartnerFunc();
    }, [getPartnerMultipleMappingListRes.data.status]);

    const dealerListPartnerReq = () => {
        setGetDealerListStatus(true);
        const Req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                division: division,
                district: district,
                thana: thana,
                union: union,
            }
        };
        dispatch(partnerDealerListReq(Req, authToken));
    };

    const DealerListPartnerFunc = () => {
        if (getDealerListStatus) {
            if (getDealerListRes.data.status == "success") {
                setGetDealerListArray([].concat(getDealerListRes.data.actionList));
            }
            if (getDealerListRes.data.status == "failed") {
                setGetDealerListArray(getDealerListRes.data);
                if (
                    getDealerListRes.data.description == "session out" ||
                    getDealerListRes.data.description == "Authorization failed"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        DealerListPartnerFunc();
    }, [getDealerListRes.data.status]);


    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            dealerListPartnerReq();
        }
    }, [regenerateTokenRes.data.status]);

    const MapDealer = () => {
        // setGetCustId(customerId)
        setEditOpenMapDsr(true)
    }

    const [blockIDS, setBlockIDS] = useState({
        blockId: []
    });

    const handleChangeCheck = (id, e) => {
        const { value, checked } = e.target;
        const { blockId } = blockIDS;
        if (checked) {
            setBlockIDS({
                blockId: [...blockId, id]
            });
        } else {
            setBlockIDS({
                blockId: blockId.filter((e) => e !== id)
            });
        }
    };

    useEffect(() => {
        if (getIsDealUsed && blockIDS.blockId) {
            setReqArr(blockIDS.blockId.map((x) => (
                {
                    walletOwnerId: regenerateTokenRes.data.partnerId,
                    dealerId: getIsDealUsed.split("-")[0],
                    agentId: x,
                    mappingId: ""
                }
            )))
        }
    }, [getIsDealUsed, blockIDS.blockId])

    const getMapDealerReq = () => {
        setMapDsrStatus(true)
        const req = {
            actionCustomerMasterRequestVOList: reqArr
        }

        dispatch(partnerGetMultipleSelectListReq(req, authToken))
        setEditOpenMapDsr(false)
    }
    const CheckListDsrFunc = () => {
        if (mapDsrStatus) {
            if (getCheckListRes.data.status == "success") {
                setMapDsrStatusResArray(getCheckListRes.data)
                setCheckListNotification(true)
                getMultipleMappingListPartnerReq()

            }
            if (getCheckListRes.data.status == "failed") {
                setMapDsrStatusResArray(getCheckListRes.data)
                setCheckListNotification(true)
            }
        }
    }

    useEffect(() => {
        CheckListDsrFunc()
    }, [getCheckListRes.data.status])

    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >


                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                margin="dense"
                                autoFocus={true}
                                label="Role"
                                fullWidth={true}
                                name="role"
                                // value={getRole || ""}
                                defaultValue={"Select Role" || getRole}
                            // onChange={handleChange}
                            >
                                <MenuItem value="Select Role" selected="Select Role">
                                    Select Role
                                </MenuItem>
                                <MenuItem value="MERCHANT">MERCHANT</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">

                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Division"
                                fullWidth={true}

                                // defaultValue={division || "Select Divison"}
                                // onChange={(e) => onInputChangeMod(e)}
                                name="EditDivision"
                                value={editDivision || ""}
                                onChange={handleChange}

                            >
                                <MenuItem value="Select Divison" selected="Select Divison">
                                    Select Division
                                </MenuItem>
                                {/* {setDivisionList.success} */}
                                {setDivisionList.success &&
                                    setDivisionList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>

                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">
                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="District"
                                fullWidth={true}
                                // name="district"
                                // defaultValue={district || "Select District"}
                                // onChange={(e) => onInputChangeMod(e)}
                                name="EditDistrict"
                                value={editDistrict || ""}

                                onChange={handleChange}
                            >
                                <MenuItem value="Select District" selected="Select District">
                                    Select District
                                </MenuItem>
                                {setDistrictList.success &&
                                    setDistrictList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">
                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Thana/Upazilla"
                                fullWidth={true}
                                // name="thana"
                                // defaultValue={thana || "Select Thana/Upazilla"}
                                // onChange={(e) => onInputChangeMod(e)}
                                name="EditThana"
                                value={editThana || ""}

                                onChange={handleChange}
                            >
                                <MenuItem value="Select Thana/Upazilla" selected="Select Thana/Upazilla">
                                    Select Thana/Upazilla
                                </MenuItem>

                                {setThanaList.success &&
                                    setThanaList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">

                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Union/Ward"
                                fullWidth={true}
                                // name="union"
                                // defaultValue={union || "Select Union/Ward"}
                                // onChange={(e) => onInputChangeMod(e)}
                                name="EditUnion"
                                value={editUnion || ""}

                                onChange={handleChange}
                            >
                                <MenuItem value="Select Union/Ward" selected="Select Union/Ward">
                                    Select Union/Ward
                                </MenuItem>
                                {setUnionList.success &&
                                    setUnionList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>


                        <Grid item xs={12} sm={6} md={4} lg={3}>

                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={getMultipleMappingListPartnerReq}
                            >
                                Search
                                <SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
                            </CustomButton>

                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />

                ) : getDealerMultiplMappingListStatusArray.length == undefined ||
                    !getDealerMultiplMappingListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 themeBackground"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography
                                        variant="body1"
                                        style={{ fontWeight: "700" }}
                                        className="themeText"
                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="text-nowrap my-3">
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow
                                                style={{ background: "#00b9f5" }}
                                                className="themeBackground"
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >

                                                    Action
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    {" "}
                                                    Agent ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    {" "}
                                                    Agent/Combo name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Division
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    District
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Thana
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Union
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Role
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {getDealerMultiplMappingListStatusArray &&
                                                []
                                                    .concat(getDealerMultiplMappingListStatusArray)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                <input
                                                                    type="checkbox"
                                                                    key={row.blockId}
                                                                    onChange={(e) => handleChangeCheck(row.customerId, e)}
                                                                />
                                                            </TableCell>
                                                            <TableCell align="center">{row.customerId}</TableCell>
                                                            <TableCell align="center">
                                                                {row.customerName}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.division}
                                                            </TableCell>


                                                            <TableCell align="center">{row.district}</TableCell>
                                                            <TableCell align="center">
                                                                {row.thana}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.union}
                                                            </TableCell>
                                                            <TableCell align="center">{row.userRole}</TableCell>
                                                        </TableRow>
                                                    )

                                                    )}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(getDealerMultiplMappingListStatusArray).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={handleChangePage}
                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                    />
                                    <div className="text-center">

                                        <CustomButton
                                            style={{
                                                padding: "8px"
                                            }}
                                            onClick={() => MapDealer()}
                                        >
                                            Map Dealer
                                        </CustomButton>
                                    </div>
                                </TableContainer>

                            </Grid>

                        </Card>

                    </div>
                )
                }
            </Layout>


            <div>
                <Dialog open={editOpenMapDsr} onClose={handleClose}>
                    <DialogTitle>Update Dsr Mapping</DialogTitle>
                    <DialogContent>


                        <div style={{ marginTop: "1.5rem" }}>

                            <TextField
                                required
                                select
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Dsr"
                                fullWidth={true}
                                // name="dsr"
                                name="getIsDealUsed"
                                value={getIsDealUsed || ""}
                                // value={level || ""}
                                // defaultValue={"Select Dsr" || dsr}
                                onChange={handleChange}
                            >
                                <MenuItem value="Select Dsr" selected="Select Level">
                                    Select Dsr
                                </MenuItem>

                                {/* {setDsrList.success} */}
                                {/* <MenuItem value="BASIC">BASIC</MenuItem> */}
                                {getDealerListRes.success && [].concat(getDealerListRes.data.actionList)
                                    .map((x) => <MenuItem value={x}
                                    >{x}</MenuItem>)}

                            </TextField>
                        </div>
                    </DialogContent>

                    <DialogActions>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#00b9f5",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={getMapDealerReq}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>


            </div>


            {getCheckListRes.data.status == "success" && (
                <div>
                    <Dialog open={checkListNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mapDsrStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getCheckListRes.data.status == "failed" && (
                <div>
                    <Dialog open={checkListNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mapDsrStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default DealerMultipleMapping